module.exports = __webpack_public_path__ + "static/media/increase.29478b82.svg";